export default "__VITE_ASSET__BgAQ73BW__"